import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { select, Store } from '@ngrx/store';
import { LoadSlumpCatalogAction, LoadSlumpFilteredCatalogAction } from '../../../actions/single-catalogs.actions';
import { filter, map, take } from 'rxjs/operators';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { getOpenPlatformProducts } from '../../../selectors/products.selectors';
import { makeReference } from '@ordersnproducts/utils/mix-reference';
import { getOpenPlatformProductAddedValues } from '../../../selectors/added-value.selectors';

@Injectable()
export class LoadSingleCatalogsSlump implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getOpenPlatformProducts),
        filter((products) => !!value && !!products.length),
        take(1),
        map((products) =>
          products.find((product) => _safe(() => product.productCode.replace(/^0+/, '') === value, false)),
        ),
      )
      .subscribe((product) => {
        if (product) {
          this.store.dispatch(new LoadSlumpCatalogAction());
        }
      });
  }
}

@Injectable()
export class LoadSingleCatalogsSlumpMixRef implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getOpenPlatformProducts),
        filter((products) => !!value && !!products.length),
        take(1),
        map((products) => products.find((product) => makeReference(product) === value)),
      )
      .subscribe((product) => {
        const technicalProductCode = _safe(() => product.technicalProducts[0].technicalProductCode);
        if (technicalProductCode) {
          this.store.dispatch(new LoadSlumpCatalogAction());
        }
      });
  }
}

/**
 * Triggers slump catalog load for request experience
 */
@Injectable()
export class LoadSingleCatalogsSlumpRequest implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}
  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store.dispatch(new LoadSlumpCatalogAction());
  }
}

/**
 * Used only for FR
 */
@Injectable()
export class LoadFilteredCatalogSlumpMixRef implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getOpenPlatformProductAddedValues('undefined_0')),
        filter((availableVaps) => !!availableVaps && !availableVaps[0].loading),
        take(1),
      )
      .subscribe((availableVaps) => {
        let technicals = [];
        Object.keys(availableVaps).forEach((vapKey) => {
          if (availableVaps[vapKey].technicalProduct.length > 0) {
            technicals = availableVaps[vapKey].technicalProduct;
          }
        });
        this.store.dispatch(new LoadSlumpFilteredCatalogAction(technicals));
      });
  }
}
